module.exports = __webpack_public_path__ + "cloud-5.svg?0ed5737f552df8faafc80bb02e1a2b5a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-5.svg
// module id = 156
// module chunks = 0